var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-text",
                {
                  staticClass: "app-title",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "w100" },
        [
          _vm.$wf.isMdUp
            ? _c("w-breadcrumb", { attrs: { crumbs: _vm.path } })
            : _vm._e(),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "app-browse-list",
                        {
                          attrs: { browses: _vm.browses, title: _vm.title },
                          on: {
                            click: function ($event) {
                              return _vm.onBrowseClick($event)
                            },
                          },
                        },
                        [
                          _c(
                            "w-dropdown",
                            {
                              attrs: {
                                slot: "actions",
                                sm: "",
                                flat: "",
                                items: _vm.actions,
                                right: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.actionClicked($event)
                                },
                              },
                              slot: "actions",
                            },
                            [_c("w-fa", { attrs: { icon: "ellipsis-v" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isOwner
                    ? _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-visible-links", {
                            attrs: { "user-id": _vm.userId },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-user-import-views", {
        attrs: { "user-id": _vm.userId },
        model: {
          value: _vm.importOpen,
          callback: function ($$v) {
            _vm.importOpen = $$v
          },
          expression: "importOpen",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }